import type { ExtendedPrice } from 'src/areas/product/components/product-context';
import type { AlternativePrice, Price } from 'src/types';

export const replaceMainOfferWithAlternativeOffer = (
  offer: ExtendedPrice,
  alternativeOffer: AlternativePrice
) => {
  if (!alternativeOffer) return offer;

  const newAlternatives = [
    alternativeOffer,
    ...offer.alternativePrices!.filter(alt => alt !== alternativeOffer),
  ];

  return {
    ...alternativeOffer,
    authorizedDealer: offer.authorizedDealer,
    history: offer.history,
    store: offer.store,
    unfilteredShippings: offer.unfilteredShippings,
    alternativePrices: newAlternatives,
  } as Price;
};
